module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-em-big-white-f092e28212120ba76d88bd81e5dbe8a0.svg";